import { LOAD, LOAD_ANSWER, SET_STATUS } from './constants'
import { IInquiry, IAnswer, Status } from './types'

export function loadInquiry(inquiry: IInquiry) {
  return {
    type: LOAD,
    payload: {
      inquiry
    }
  }
}

export function loadAnswer(calculatorId: string, answer: IAnswer) {
  return {
    type: LOAD_ANSWER,
    payload: {
      calculatorId,
      answer
    }
  }
}

export function setInquiryStatus(calculatorId: string, status: Status) {
  return {
    type: SET_STATUS,
    payload: {
      calculatorId,
      status
    }
  }
}
